// removed by extract-text-webpack-plugin
module.exports = {"main":"_1OF1bBUVIQ7cmUFbHvUBcN"};


//////////////////
// WEBPACK FOOTER
// ./ui/CircularLogo/index.module.css
// module id = 2416
// module chunks = 0